/**
 * KAN-804: металлы призовых мест (эпик редизайна итогов).
 *
 * В `shared/` по той же причине, что и цвет балла: медали нужны и пьедесталу, и
 * карточкам команд, и старому `tournament-detail/tournament-podium.tsx`, где эти
 * же значения пока продублированы хексами. Импорт виджета из виджета запрещён
 * (`ai/module-graph.md`), значит общее место — `shared/`.
 *
 * Золото, серебро и бронза — не цвета темы, а свойства медали: они одинаковы в
 * светлой и тёмной, и токенами их не выражают. В проекте они уже так и живут —
 * теми же значениями в `widgets/tournament-detail/tournament-podium.tsx`. Здесь тот
 * же набор, вынесенный из одного файла, чтобы пьедестал, карточки команд и бейджи
 * мест не разъехались по оттенкам.
 */

export type MedalKey = "gold" | "silver" | "bronze";

export interface Medal {
  /** Основной оттенок: подписи, цифры, обводки. */
  mid: string;
  /** Градиент металла — для дисков мест и текста с background-clip. */
  bar: string;
}

export const MEDALS: Record<MedalKey, Medal> = {
  gold: {
    mid: "#f59e0b",
    bar: "linear-gradient(90deg,#fef3c7,#fbbf24 34%,#b45309)",
  },
  silver: {
    mid: "#94a3b8",
    bar: "linear-gradient(90deg,#f1f5f9,#cbd5e1 34%,#64748b)",
  },
  bronze: {
    mid: "#ea580c",
    bar: "linear-gradient(90deg,#fed7aa,#fb923c 34%,#9a3412)",
  },
};

/**
 * Металл по месту. Ниже третьего медали нет — и это не «нет данных», а факт: за
 * четвёртое место не награждают, и подкрашивать его как призовое нельзя.
 */
export function medalOf(placement?: number | null): Medal | null {
  if (placement === 1) return MEDALS.gold;
  if (placement === 2) return MEDALS.silver;
  if (placement === 3) return MEDALS.bronze;
  return null;
}

/**
 * Подмешивает металл к токену темы. `color-mix` даёт оттенок, который остаётся
 * читаемым в обеих темах: подложка берётся из токена, а характер — от металла.
 */
export function medalMix(medal: Medal | null, percent: number, base: string): string {
  return medal ? `color-mix(in srgb, ${medal.mid} ${percent}%, ${base})` : base;
}
